import Event from '../../event';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';
import { getBrowser } from '../utils';

const Events = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'volumechange',
];

class AdCore extends Component {
    static propTypes = {
        frontAd: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.opt = props;
        this.state = {
            isRender: true,
        };
        this.event = new Event();
        this.eventCache = [];
    }
    componentDidMount() {
        const value = this.props.frontAd.vol; // 获取广告音量
        const refs = this.refs;

        this.el = this.refs;
        // console.log(value);
        for (const key in refs) {
            // if (getBrowser() === 'Safari' || getBrowser() === 'Chrome') {
            //     // refs[key].muted = true;
            //     // refs[key].volume = 0;
            // } else {
            refs[key].volume = value[key]; // 设置音量
            // }
        }

        // this.el[0].addEventListener('canplay', () => {
        //     // console.log('canplay');
        //     this.trigger('canplay');
        // });
    }

    // AD播放后调高音量
    adStartHVolume() {
        const refs = this.refs;

        for (const key in refs) {
            const item = refs[key];

            item.volume = this.props.frontAd.vol;
        }
    }
    cancelVideoMuted() {
        const refs = this.refs;

        for (const key in refs) {
            const item = refs[key];

            item.muted = false;
            item.volume = this.props.frontAd.vol;
        }
    }

    // 播放
    adPlay(index) {
        if (index > 0) {
            this.el[index - 1].style.display = 'none';
        }
        this.el[index].style.display = 'block';
        this.el[index].play().catch(err => {
            console.log(err);
            this.el[index].volume = 0;
            this.el[index].muted = true;
            this.event.trigger('mutePlay');
            this.el[index].play();
        });

        this.dom = this.el[index];
        this.clickUrl = this.opt.frontAd.clickUrl[index];
    }
    // 静音
    adVolume() {
        const refs = this.refs;

        for (const key in refs) {
            const item = refs[key];

            if (item.volume === 0) {
                item.volume = 1;
            } else {
                item.volume = 0;
            }
        }
    }

    on(eventName, callback, ele) {
        this.eventCache.push({ eventName, callback, ele });
        if (Events.indexOf(eventName) >= 0) {
            ele.addEventListener(eventName, callback, false);
        } else {
            this.event.on(eventName, callback);
        }
    }

    off(eventName, callback, ele) {
        if (Events.indexOf(eventName) >= 0) {
            ele.removeEventListener(eventName, callback);
        } else {
            this.event.off(eventName, callback);
        }
    }

    destory() {
        this.setState({
            isRender: false,
        });
    }

    getChildren() {
        return this.props.frontAd.adUrl.map((src, i) => {
            return (
                <video
                    key={i}
                    className={styles.advideo}
                    data-tag={i}
                    ref={i}
                    poster="//p1.ifengimg.com/a/2016/1021/loading0.jpg"
                    src={src}
                    id="adPlayer"
                    preload="auto"
                />
            );
        });
    }

    render() {
        const { isRender } = this.state;
        const children = this.getChildren();

        return isRender ? children : null;
    }
}

// Event.mixTo(AdCore);
export default AdCore;
